module.exports = __webpack_public_path__ + "img/nav-right-expand-search-honda.c83eea32.png";